var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar-entry c-notification p-4",class:_vm.color},[_c('h4',{staticClass:"c-notification-header"},[_vm._v(" "+_vm._s(_vm.header)+" ")]),_c('p',{staticClass:"c-notification-body"},[_vm._v(" "+_vm._s(_vm.body)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }